import React from "react";
import { IToolbarProps } from ".";
import { ToolbarButton } from "./toolbarButton";

interface IToggleButtonProps extends IToolbarProps {
  type: string;
  children?: React.ReactChild;
}

export const ToggleButton = ({ editorRef, type, children }: IToggleButtonProps) => {
  const queryName = `isToggled_${type}`;
  const commandName = `toggle_${type}`;

  const onClick = () => {
    /**
     * NB can't use editorRef.toggleMark(type) as blockquote is not a mark
     * instead each entity uses toggleCommands.addToggleCommand() to register
     * a custom toggle command named `toggle_[type]`.
     */
    editorRef.command(commandName);
    editorRef.focus();
  };

  return (
    <ToolbarButton active={editorRef[queryName]()} onClick={onClick}>
      {children}
    </ToolbarButton>
  );
};
